import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimezone',
  standalone: true
})
export class DateTimezonePipe implements PipeTransform {
  
  transform(dateString: string | Date | number, format: string = 'medium', timezone: string = 'local'): string {
    if (!dateString) {
      return '-';
    }

    try {
      let date: Date;
      
      // Farklı veri tiplerini handle et
      if (typeof dateString === 'string') {
        // DD-MM-YYYY HH:mm:ss formatını kontrol et
        const ddMMyyyyPattern = /^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
        const match = dateString.match(ddMMyyyyPattern);
        
        if (match) {
          // DD-MM-YYYY HH:mm:ss formatını parse et
          const [, day, month, year, hour, minute, second] = match;
          
          if (timezone === 'utc') {
            // UTC olarak parse et (backend'den gelen saat UTC olarak kabul edilir)
            date = new Date(Date.UTC(
              parseInt(year),
              parseInt(month) - 1, // Ay 0-based olduğu için -1
              parseInt(day),
              parseInt(hour),
              parseInt(minute),
              parseInt(second)
            ));
          } else {
            // Yerel saat dilimi olarak parse et
            date = new Date(
              parseInt(year),
              parseInt(month) - 1, // Ay 0-based olduğu için -1
              parseInt(day),
              parseInt(hour),
              parseInt(minute),
              parseInt(second)
            );
          }
        } else {
          // Standart Date constructor kullan
          date = new Date(dateString);
        }
      } else if (typeof dateString === 'number') {
        // Timestamp ise Date objesine çevir
        date = new Date(dateString);
      } else if (dateString instanceof Date) {
        // Zaten Date objesi ise kullan
        date = dateString;
      } else {
        return '-';
      }
      
      // Geçersiz tarih kontrolü
      if (isNaN(date.getTime())) {
        return '-';
      }

      // Format seçenekleri
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };

      // Eğer UTC olarak parse edildiyse, Türkiye zaman dilimine çevir
      if (timezone === 'utc') {
        options.timeZone = 'Europe/Istanbul';
      }

      // Format tipine göre seçenekleri ayarla
      switch (format) {
        case 'short':
          options.second = undefined;
          break;
        case 'medium':
          // Varsayılan ayarlar kullanılacak
          break;
        case 'long':
          options.weekday = 'long';
          options.month = 'long';
          break;
        case 'dateOnly':
          options.hour = undefined;
          options.minute = undefined;
          options.second = undefined;
          break;
        case 'timeOnly':
          options.year = undefined;
          options.month = undefined;
          options.day = undefined;
          break;
        default:
          break;
      }

      const result = new Intl.DateTimeFormat('tr-TR', options).format(date);
      return result;
    } catch (error) {
      console.error('Tarih formatlanırken hata oluştu:', error);
      return '-';
    }
  }
} 